module.exports = __webpack_public_path__ + "static/co-infographic-fc6d8d1d1c6c37d82b0afcaa4cdfc89a.svg";